module.exports = __webpack_public_path__ + "img/16.05e44e9f.png";